<template>
  <div class="grid-view">
    <div class="main-content account-title">
      <div class="section operations">
        <div class="filters">
          <span style="margin-right: 5px">{{ $t('CargoMsg.Cargo_Category') }}</span>
          <el-button :type="assetsType" @click="categoryClickHandler(1)">{{ $t('FinanceManage.Assets') }}</el-button>
          <el-button :type="liabilityType" @click="categoryClickHandler(2)">{{ $t('FinanceManage.Liabilities') }}</el-button>
          <el-button :type="equityType" @click="categoryClickHandler(3)">{{ $t('FinanceManage.Equity') }}</el-button>
          <el-button :type="costType" @click="categoryClickHandler(4)">{{ $t('FinanceManage.Cost') }}</el-button>
          <el-button :type="interestType" @click="categoryClickHandler(5)">{{ $t('FinanceManage.ProfitAndLoss') }}</el-button>
          <el-button v-if="btnAddVisible" type="primary" @click="addHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button v-if="btnDelVisible" type="danger" :disabled="!selectedRow" @click="delHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px"
        />
      </div>
      <account-title-edit-dialog
        :v-if="editDialog.visible"
        :visible.sync="editDialog.visible"
        :account-title-type="accountTitleType"
        :account-title="editDialog.accountTitle"
        :super-account-title="editDialog.superAccountTitle"
        :has-sub="editDialog.hasSub"
        :account-set="accountSet"
        @success="saveSuccess"
      />
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import * as accountingDocumentTypeApi from '@/api/financeManage/accountingDocumentType'
import * as accountTitleApi from '@/api/financeManage/accountTitle'
import AccountTitleEditDialog from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleEditDialog'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as AccountTitleType from '@/class/cargo/model/parameters/AccountTitleType'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'AccountTitleList',
  components: { AccountTitleEditDialog },
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      selectedRow: null, // 是否选中行
      documentManage: new DocumentManage(),
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        onRowClicked: this.onRowClickedHandler
      },
      rowData: [],
      locked: true,
      assetsType: '',
      liabilityType: '',
      equityType: '',
      costType: '',
      interestType: '',
      accountTitleType: 1,
      editDialog: {
        visible: false,
        accountTitle: null,
        superAccountTitle: null,
        hasSub: false
      }
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Coding'),
          field: 'accountTitle',
          width: 100,
          editable: !this.locked,
          sortable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'accountTitleName',
          width: 150,
          editable: !this.locked,
          sortable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params),
          valueFormatter: params => {
            return this.nameLabelFun(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Category'),
          field: 'subType',
          width: 100,
          editable: !this.locked,
          sortable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params),
          valueFormatter: params => {
            const state = CommonState.getStateByCode(AccountTitleType.ACCOUNT_TITLE_TYPE, params.value)
            return state ? this.$getLangColumn(state) : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BalanceDirection'),
          field: 'debitCrebit',
          width: 100,
          editable: !this.locked,
          sortable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params),
          valueFormatter: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Debit') : this.$t('CargoMsg.Cargo_Credit')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SubsidiaryAccounting'),
          field: '',
          width: 250,
          editable: !this.locked,
          sortable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params),
          valueFormatter: params => {
            return this.auxiliaryLabelFun(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AmountNumber'),
          field: 'unit',
          width: 80,
          editable: !this.locked,
          sortable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: this.$t('CargoMsg.Cargo_ForeignCurrency'),
          field: 'sourceCurrency',
          width: 200,
          editable: !this.locked,
          sortable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params),
          valueFormatter: params => {
            return this.currencyLableFun(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          width: 120,
          sortable: false,
          cellRenderer: params => {
            const addMethodPath = this.documentManage.getPath('toAdd')
            const editMethodPath = this.documentManage.getPath('toEdit')
            const delMethodPath = this.documentManage.getPath('toDel')
            return `<div onclick="${addMethodPath}('${params.data.uuid}')" style="display: inline-block;color:green;margin-right: 5px;cursor: pointer">${this.$t('FinanceManage.Add')}</div>
                    <div onclick="${editMethodPath}('${params.data.uuid}')" style="display: inline-block;color:green;margin-right: 5px;cursor: pointer">${this.$t('FinanceManage.Edit')}</div>
                    <div onclick="${delMethodPath}('${params.data.uuid}')" style="display: inline-block;color:red;margin-right: 5px;cursor: pointer">${this.$t('FinanceManage.Delete')}</div>`
          }
        }
      ]
    },
    btnAddVisible() {
      return this.$checkPermission(['button_AccountSetAccountTitleNew'])
    },
    btnDelVisible() {
      return this.$checkPermission(['button_AccountSetAccountTitleDelete'])
    }
  },
  created() {
    this.categoryClickHandler(this.accountTitleType)
  },
  beforeMount() {
    this.documentManage.set('toAdd', uuid => {
      this.toAddHandler(uuid)
    })
    this.documentManage.set('toEdit', uuid => {
      this.toEditHandler(uuid)
    })
    this.documentManage.set('toDel', uuid => {
      this.toDelHandler(uuid)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    saveHandler() {
      const saveList = []
      for (const row of this.rowData) {
        if (['add', 'edit'].includes(row.waitDealStatus)) {
          saveList.push(row)
        }
      }
      if (saveList.length) {
        // 校验
        for (const row of saveList) {
          if (!row.name) {
            this.$message.info(this.$t('CargoMsg.Cargo_PleaseEnterVoucherType'))
          } else if (!row.prefix) {
            this.$message.info(this.$t('CargoMsg.Cargo_PleaseEnterVoucherLetter'))
          }
        }
        // 保存
        const loading = getLoading()
        accountingDocumentTypeApi.save(saveList).then(resp => {
          this.saveSuccess(resp)
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
      }
      this.locked = true
    },
    cancelHandler() {
      this.locked = true
      this.loadList()
    },
    loadList() {
      const loading = getLoading()
      const params = {}
      params.accountingSetKey = this.accountSet.uuid
      params.accountTitleType = this.accountTitleType
      if (this.accountSet.currentFiscalPeriod) params.year = this.accountSet.currentFiscalPeriod.year
      accountTitleApi.query(params).then(resp => {
        this.rowData = resp.data.list
        if (this.gridOptions.api) {
          this.gridOptions.api.refreshCells({ force: true })
        }
      }).finally(() => {
        loading.close()
        if (this.gridOptions.api) {
          this.gridOptions.api.clearFocusedCell()
        }
      })
      this.selectedRow = null
    },
    async refreshHandler() {
      this.loadList()
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
    },
    saveSuccess(data) {
      // 返回的数据是编辑的或新增的数据
      if (!data) return
      const index = this.rowData.findIndex(params => params.uuid === data.uuid)
      if (index > -1) {
        Object.assign(this.rowData[index], data)
      } else {
        this.rowData.push(data)
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      // this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    categoryClickHandler(code) {
      this.assetsType = ''
      this.liabilityType = ''
      this.equityType = ''
      this.costType = ''
      this.interestType = ''
      this.accountTitleType = code
      const type = 'info'
      switch (code) {
        case 1:
          this.assetsType = type
          break
        case 2:
          this.liabilityType = type
          break
        case 3:
          this.equityType = type
          break
        case 4:
          this.costType = type
          break
        case 5:
          this.interestType = type
          break
        default:
      }
      this.loadList()
    },
    nameLabelFun(params) {
      let result = ''
      if (params.value) {
        for (let i = 1; i < params.data.level; i++) {
          result += '    '
        }
        result += params.value.toString()
      }
      return result
    },
    auxiliaryLabelFun(params) {
      let result = ''
      const accountTitle = params.data
      if (accountTitle.auxiliary) {
        if (accountTitle.auxiliaryCustomer) {
          if (result !== '') {
            result += '/'
          }
          result += this.$t('CargoMsg.Cargo_Customer')
        }

        if (accountTitle.auxiliarySupplier) {
          if (result !== '') {
            result += '/'
          }
          result += this.$t('CargoMsg.Cargo_Vendor')
        }

        if (accountTitle.auxiliarySales) {
          if (result !== '') {
            result += '/'
          }
          result += this.$t('CargoMsg.Cargo_Staff')
        }

        if (accountTitle.auxiliaryProjectNumber) {
          if (result !== '') {
            result += '/'
          }
          result += this.$t('CargoMsg.Cargo_Item')
        }

        if (accountTitle.auxiliaryDepartment) {
          if (result !== '') {
            result += '/'
          }
          result += this.$t('CargoMsg.Cargo_Department')
        }
      }
      return result
    },
    currencyLableFun(params) {
      let result = ''
      const data = params.data
      if (params.value) {
        result = params.value.toString()
        result = result.split(',').join('/')
      }
      // 外币核算false
      if (!data.accountingCurrency) {
        result = ''
      }
      if (result === this.accountSet.localCurrency) {
        result = ''
      }
      return result
    },
    removeOne() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedRow : null
      this.deleteBatch([currentRow])
    },
    addHandler() {
      this.editDialog.accountTitle = null
      this.editDialog.superAccountTitle = null
      this.editDialog.hasSub = false
      this.editDialog.visible = true
    },
    async delHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        return
      }
      this.deleteBatch(rows)
    },
    async deleteBatch(rows) {
      await this.$confirm(this.$t('CargoMsg.Cargo_STDTATNRAD'), this.$t('common.tips.prompt'), { type: 'warning' })
      const uuids = rows.map(row => row.uuid)
      accountTitleApi.remove({ uuids }).then(resp => {
        uuids.forEach(uuid => this.removeSuccess(uuid))
      })
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    toAddHandler(uuid) {
      const data = this.rowData.find(row => row.uuid === uuid)
      this.editDialog.superAccountTitle = data
      this.editDialog.accountTitle = null
      this.editDialog.visible = true
    },
    toEditHandler(uuid) {
      const data = this.rowData.find(row => row.uuid === uuid)
      this.editDialog.hasSub = this.hasSubAccountTitle(data, this.rowData)
      this.editDialog.superAccountTitle = this.getSuperAccountTitle(data, this.rowData)
      this.editDialog.accountTitle = data
      this.editDialog.visible = true
    },
    toDelHandler(uuid) {
      const data = this.rowData.find(row => row.uuid === uuid)
      this.deleteBatch([data])
    },
    hasSubAccountTitle(accountTitle, arrayCollection) {
      if (!accountTitle || !accountTitle.accountSet ||
        accountTitle.level === this.accountSet.accountTitleGradeRule.length) {
        return false
      }
      const subLevel = accountTitle.level + 1
      for (const item of arrayCollection) {
        if (item.level === subLevel && item.accountTitleType === accountTitle.accountTitleType) {
          let itemFlag = true
          for (let i = 1; i < subLevel; i++) {
            if (item['accountItem' + i] === accountTitle['accountItem' + i]) {
              continue
            }
            // 有不相同的accountItem
            itemFlag = false
          }
          if (itemFlag) {
            return true
          }
        }
      }
      return false
    },
    getSuperAccountTitle(value, arrayCollection) {
      if (value == null || arrayCollection == null || arrayCollection.length === 0) {
        return null
      }
      const level = value.level
      if (level > 1) {
        const superLevel = level - 1
        for (const accountTitle of arrayCollection) {
          if (accountTitle.level === superLevel && accountTitle.accountTitleType === value.accountTitleType) {
            let valueFlag = true
            for (let i = 1; i < level; i++) {
              if (value['accountItem' + i] === accountTitle['accountItem' + i]) {
                continue
              }
              valueFlag = false
            }
            if (valueFlag) { return accountTitle }
          }
        }
      }
      return null
    },
    onRowClickedHandler(event) {
      this.selectedRow = event.data
    }
  }
}
</script>

<style scoped>

</style>
